import eventQueue from '../queue';
function attachEventListener() {
    eventQueue.on('link_api_response', function (_a) {
        var response = _a.response, state = _a.state, fireClientEvent = _a.fireClientEvent;
        if (!state.linkParams.featureFlags.inputRequiredEventEnabled)
            return;
        if (response.responseType !== 'next' &&
            response.responseType !== 'next_with_error')
            return;
        if (response.template.templateType === 'edge_native')
            return;
        if (response.template.templateType === 'form') {
            for (var _i = 0, _b = response.template.fields; _i < _b.length; _i++) {
                var field = _b[_i];
                fireClientEvent('other_event', {
                    name: 'input_required_details',
                    payload: [
                        {
                            key: 'input_type',
                            type: 'string',
                            value: field.key,
                        },
                    ],
                });
            }
        }
        fireClientEvent('input_required', {});
    });
}
attachEventListener();
